import React from 'react';
import { theme } from '../../config/theme';

const Card = ({ 
  children, 
  title,
  subtitle,
  padding = 'lg',
  hoverable = false,
  onClick,
  className = '',
  style = {}
}) => {
  const paddingMap = {
    none: 0,
    sm: theme.spacing.md,
    md: theme.spacing.lg,
    lg: theme.spacing.xl,
    xl: theme.spacing['2xl'],
  };

  const cardStyles = {
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.lg,
    border: `1px solid ${theme.colors.gray[200]}`,
    padding: paddingMap[padding],
    transition: theme.transitions.base,
    cursor: onClick ? 'pointer' : 'default',
    ...style,
  };

  const hoverStyles = hoverable ? {
    boxShadow: theme.shadows.md,
    borderColor: theme.colors.gray[300],
  } : {};

  const titleStyles = {
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.semibold,
    color: theme.colors.text.primary,
    marginBottom: subtitle ? theme.spacing.xs : theme.spacing.md,
  };

  const subtitleStyles = {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.text.secondary,
    marginBottom: theme.spacing.md,
  };

  return (
    <div
      className={className}
      style={cardStyles}
      onClick={onClick}
      onMouseEnter={(e) => hoverable && Object.assign(e.currentTarget.style, hoverStyles)}
      onMouseLeave={(e) => hoverable && Object.assign(e.currentTarget.style, { boxShadow: 'none', borderColor: theme.colors.gray[200] })}
    >
      {(title || subtitle) && (
        <div style={{ marginBottom: theme.spacing.md }}>
          {title && <h3 style={titleStyles}>{title}</h3>}
          {subtitle && <p style={subtitleStyles}>{subtitle}</p>}
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;